/**
 * Media text — optional logo strip under the text (The Experience "Where great minds gather", TZ section 6):
 * logos scroll horizontally in a continuous loop. Logic: utils/logo-marquee.js.
 */
import {initLogoMarquee} from "../../utils/logo-marquee.js";

const SPEED = 25; // px per second — lower = slower

export const mediaText = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.media-text__logos').forEach((strip) => initLogoMarquee(strip, {
            track: '.media-text__logos-track',
            group: '.media-text__logos-group',
            speed: SPEED,
        }));
        resolve();
    });
};
